// The heading block every timetable workspace panel opens with: title, an
// optional count beside it, a subtitle, and an optional right-hand action.
//
// It exists because the panels had hand-copied versions of the same two class
// strings, and they had already drifted after one sitting — some wrapped in
// `mb-2` and some didn't, some carried the count and some didn't.
//
// It carries NO bottom margin. It used to (`mb-2`), which meant a panel that
// dropped it into a `space-y-*` stack got 8px on top of the stack's gap while a
// panel that didn't got 8px total — so the first card of a panel started at a
// different y-offset depending on which tab you were on. Rhythm belongs to
// `Panel` (PanelKit), and only there.
export default function PanelHeader({ title, count, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        {/* h2, not h3. BaseLayout's header bar is the page's <h1>, so an <h3>
            here skipped a level on every tab — and on School week it also made
            the panel title the same rank as the three section headings it
            contains. The panels' own section headings stay <h3>. */}
        <h2 className="text-lg font-bold text-slate-900">
          {title}
          {/* slate-400 on white is 2.6:1 at a normal-weight 18px. */}
          {count != null && (
            <span className="font-normal text-slate-500"> ({count})</span>
          )}
        </h2>
        {subtitle && (
          <p className="mt-1 max-w-2xl text-xs font-medium leading-relaxed text-slate-500">
            {subtitle}
          </p>
        )}
      </div>
      {children}
    </div>
  );
}
